var _path, _path2, _path3, _path4;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
import { forwardRef } from "react";
const SvgZip = (_ref, ref) => {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 37,
    height: 21,
    viewBox: "0 0 37 21",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: ref,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M4.16833 3C2.39431 3 0.973684 4.44367 0.973684 6.20259V14.7974C0.973684 16.5563 2.39431 18 4.16833 18H32.8317C34.6057 18 36.0263 16.5563 36.0263 14.7974V6.20259C36.0263 4.44368 34.6057 3 32.8317 3H4.16833ZM0 6.20259C0 3.87174 1.87589 2 4.16833 2H32.8317C35.1241 2 37 3.87174 37 6.20259V14.7974C37 17.1283 35.1241 19 32.8317 19H4.16833C1.87589 19 0 17.1283 0 14.7974V6.20259Z",
    fill: "#005FAD"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M16.6257 12.2311H13.7506L16.6083 8.19538V7H12.0368V8.26024H14.8296L12 12.3046V13.5H16.6257V12.2311Z",
    fill: "#005FAD"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M19.1691 7V13.5H17.6005V7H19.1691Z",
    fill: "#005FAD"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M21.8316 13.5V11.2195H22.8001C23.2487 11.2323 23.694 11.1398 24.1 10.9493C24.4365 10.7853 24.7169 10.5259 24.906 10.2035C25.0916 9.87384 25.1858 9.50079 25.179 9.12272C25.1926 8.8365 25.1455 8.55062 25.0405 8.28388C24.9356 8.01714 24.7753 7.77556 24.5702 7.575C24.165 7.19023 23.5736 7 22.8001 7H20.2565V13.5H21.8316ZM22.6333 8.25808C23.2659 8.26528 23.5822 8.5535 23.5822 9.12272C23.5822 9.68042 23.2659 9.95566 22.6333 9.94845H21.8316V8.25808H22.6333Z",
    fill: "#005FAD"
  })));
};
const ForwardRef = /*#__PURE__*/forwardRef(SvgZip);
export { ForwardRef as ReactComponent };
export default __webpack_public_path__ + "static/media/zip.b87351ae70ebb804d838c0f6d7ff2dce.svg";